import { useECharts } from '@kbox-labs/react-echarts';
import { useEffect } from 'react';

import { Close, VFlex, VStack } from '@/package';

import type { PieChartData } from './type';

export const StaticPieChart = <T extends PieChartData>({
  pieData,
  onClose,
}: {
  pieData: T[];
  onClose?: () => void;
}) => {
  const data = pieData.map(item => ({
    ...item,
    value: item.aiCount + item.humanCount,
  }));

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  const [ref, echartsInstance] = useECharts<HTMLDivElement>({
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        if (!params) return '';
        const itemData = params.data;
        const value = itemData.value || 0;
        const percentage =
          totalValue > 0 ? Math.round((value / totalValue) * 100) : 0;
        const formattedValue = value.toLocaleString();
        return `<div style="font-weight: 600;">${itemData.name}</div><div style="text-align: right;">${formattedValue} <span style="color: #D3D3D3;">|</span> ${percentage.toString().padStart(2, '0')}%</div>`;
      },
      backgroundColor: '#fff',
      borderColor: '#B8E3F4',
      borderWidth: 1,
      borderRadius: 4,
      padding: [4, 8],
      textStyle: {
        color: '#333',
        fontSize: 12,
      },
    },
    series: [
      {
        type: 'pie',
        radius: ['0%', '90%'],
        center: ['50%', '50%'],
        label: { show: false },
        labelLine: { show: false },
        data,
      },
    ],
    color: data.map(item => item.color),
  });

  useEffect(() => {
    if (echartsInstance) {
      echartsInstance.resize();
    }
  }, [echartsInstance]);

  return (
    <VFlex
      className="h-[241px] w-[266px] py-4"
      justify="center"
      items="center"
      gap={1}
    >
      <VStack gap={0.5}>
        <VFlex className="w-full" gap={0.25} items="center" justify="between">
          <div className="text-body-lg">Detailed Class</div>
          <Close
            className="size-4 text-gray-400"
            role="button"
            onClick={onClose}
          />
        </VFlex>
        <VFlex className="size-full" justify="center" items="center">
          <div ref={ref} style={{ width: '200px', height: '200px' }} />
        </VFlex>
      </VStack>
    </VFlex>
  );
};
